<div class="media profile-media">
  <img class="b-r-10" src="assets/images/dashboard/profile.png" alt="">
  <div class="media-body">
    <span>{{ currentUser?.user_name || 'User' }}</span>
    <p class="mb-0 font-roboto">Admin <i class="middle fa fa-angle-down"></i></p>
  </div>
</div>

<ul class="profile-dropdown onhover-show-div">
  <li>
    <a href="/user/profile">
      <app-feather-icons [icon]="'user'"></app-feather-icons>
      <span>Account</span>
    </a>
  </li>
  <!-- <li>
    <a href="email">
      <app-feather-icons [icon]="'mail'"></app-feather-icons>
      <span>Inbox</span>
    </a>
  </li> -->
  <li>
    <a routerLink="warehouse/warehouse-list" >
      <app-feather-icons  [icon]="'file-text'"></app-feather-icons>
      <span>Warehous..</span>
    </a>
  </li>
  <!-- <li>
    <a href="/faq">
      <app-feather-icons [icon]="'settings'"></app-feather-icons>
      <span>Settings</span>
    </a>
  </li> -->
  <li (click)="logoutFunc()">
    <app-feather-icons [icon]="'log-out'"></app-feather-icons>
    <span>Log out</span>
  </li>
  
</ul>